<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div [formGroup]="dataForm" class="aside-content aside-width-full">
<div class="aside-header flex-layout-row flex-layout-align-space-between-center">
    <h3>{{saveText}} Refund</h3>
    <div class="flex-layout-gap-10px">
      <button mat-raised-button (click)="save()" color="primary" [disabled]="isSubmitting || refundPending">{{
      refundPending ? 'Refund Pending' : saveText }}</button>
      <button mat-raised-button (click)="cancel()">{{ refundPending ? 'Close' : 'Cancel' }}</button>
    </div>
  </div>
  <div class="asideOverflowScroller refund-form__body">
    <div *ngIf="refundPending" class="pending-refund-message" role="status">
      The refund is still processing. You can safely close this form; its status will continue to update.
    </div>
    <concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
    <div class="aside-content-padding">
      <div class="refund-summary flex-layout-row flex-layout-gap-10px">
        <div class="flex flex-50">
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Order Number</label>
            <label class="display-value flex flex-10">{{ dataModel?.orderNumber }}</label>
          </div>
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Event</label>
            <label class="display-value flex flex-70">{{ dataModel?.eventName }}</label>
          </div>
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Order Total (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.orderTotal | number:'1.2-2' }}</label>
          </div>
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Total Payments (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.totalPayments | number:'1.2-2' }}</label>
          </div>
          <div class='flex-layout-gap-20px' *ngIf="dataModel?.isOnPaymentPlan">
            <label class="display-label flex flex-30">Balance Outstanding (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.balanceOutstanding | number:'1.2-2'
              }}</label>
          </div>
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Refunded to Date (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.refundTotalToDate | number:'1.2-2'
              }}</label>
          </div>
        </div>

        <div class="flex flex-50">
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Customer Refund Total (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.customerRefundTotal | number:'1.2-2'
              }}</label>
          </div>
          @if(dataModel?.isOnPaymentPlan){
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Refund Payment Amount (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.refundPaymentAmount | number:'1.2-2'
              }}</label>
          </div>
          }
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Retained Refund Total (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.retainedRefundTotal | number:'1.2-2'
              }}</label>
          </div>
          <div class='flex-layout-gap-20px'>
            <label class="display-label flex flex-30">Proposed Order Total (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.proposedOrderTotal | number:'1.2-2'
              }}</label>
          </div>
          <div class='flex-layout-gap-20px' *ngIf="dataModel?.isOnPaymentPlan">
            <label class="display-label flex flex-30">Proposed Balance Outstanding (£)</label>
            <label class="display-value flex flex-10 right">{{ dataModel?.proposedBalanceOutstanding | number:'1.2-2'
              }}</label>
          </div>
        </div>

      </div>


      <div>
        <mat-radio-group formControlName="refundOption" name="refundOption" class="refund-option-radio-group">
          <mat-label class="display-label">Refund Option</mat-label>
          <mat-radio-button *ngFor="let lookup of refundOptionLookupData" [value]="lookup.id">
            <span class="radio-button-text">{{ lookup.text }}</span>
          </mat-radio-button>
        </mat-radio-group>
        <div *ngIf="refundOption.touched && dataForm.hasError('refundSelectionRequired')" class="refund-selection-error"
          role="alert">
          Select at least one item with an amount greater than £0 to refund.
        </div>
      </div>


      <div class="refund-fees flex-layout-row flex-layout-align-space-between-start">
        <div class='flex flex-50 flex-layout-column'>
          <div class="refund-fee-row flex-layout-gap-20px">
            <label class="display-label flex flex-30" style="align-self: center;">Processing Fee Paid (£)</label>
            <label class="display-value flex flex-10 right" style="align-self: center;">{{ dataModel?.processingFeePaid
              | number:'1.2-2' }}</label>
            <mat-radio-group formControlName="processingFeeRefundType">
              <div class="flex-layout-row flex-layout-align-start">
                <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
                  <span class="radio-button-text">{{ type.text }}</span>
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div class="refund-fee-row flex-layout-gap-20px">
            <label class="display-label flex flex-30" style="align-self: center;">Dispatch Method Fee Paid (£)</label>
            <label class="display-value flex flex-10 right" style="align-self: center;">{{
              dataModel?.dispatchMethodFeePaid | number:'1.2-2' }}</label>
            <mat-radio-group formControlName="dispatchMethodRefundType">
              <div class="flex-layout-row flex-layout-align-start">
                <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
                  <span class="radio-button-text">{{ type.text }}</span>
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div class="refund-fee-row flex-layout-gap-20px">
            <label class="display-label flex flex-30" style="align-self: center;">Cancellation Protection Fee Paid
              (£)</label>
            <label class="display-value flex flex-10 right" style="align-self: center;">{{
              dataModel?.cancellationProtectionFeePaid | number:'1.2-2' }}</label>
            <mat-radio-group formControlName="cancellationProtectionRefundType">
              <div class="flex-layout-row flex-layout-align-start">
                <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
                  <span class="radio-button-text">{{ type.text }}</span>
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>

          <div class="refund-fee-row flex-layout-gap-20px">
            <label class="display-label flex flex-30" style="align-self: center;">Charity Donation Amount Paid
              (£)</label>
            <label class="display-value flex flex-10 right" style="align-self: center;">{{
              dataModel?.charityDonationAmountPaid | number:'1.2-2' }}</label>
            <mat-radio-group formControlName="charityDonationRefundType">
              <div class="flex-layout-row flex-layout-align-start">
                <mat-radio-button *ngFor="let type of refundTypeLookupData" [value]="type.id">
                  <span class="radio-button-text">{{ type.text }}</span>
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>

        </div>
      </div>

      <div *ngIf="payInFullTicketsFormArray.length > 0">
        <h5>Pay In Full Tickets</h5>
        <refund-ticket-price-type-list #payInFullTickets [ticketsFormArray]="payInFullTicketsFormArray"
          [refundTypeLookupData]="refundTypeLookupData"></refund-ticket-price-type-list>
      </div>
      <div *ngIf="paymentPlanTicketsFormArray.length > 0">
        <h5>Payment Plan Tickets</h5>
        <refund-ticket-price-type-list #paymentPlanTickets [ticketsFormArray]="paymentPlanTicketsFormArray"
          [refundTypeLookupData]="refundTypeLookupData"></refund-ticket-price-type-list>
      </div>
      <div class="refund-payment-sections">

        <div *ngIf="dataModel?.payments?.length > 0">
          <h5>Payments</h5>
          <basic-payment-list [payments]="dataModel?.payments"></basic-payment-list>
        </div>
        <div *ngIf="dataModel?.remainingInstalments?.length > 0">
          <h5>Remaining Payment Plan Schedule</h5>
          <basic-payment-list [payments]="dataModel?.remainingInstalments"></basic-payment-list>
        </div>
        <div *ngIf="dataModel?.proposedRemainingInstalments?.length > 0">
          <h5>Proposed Remaining Payment Plan Schedule</h5>
          <basic-payment-list [payments]="dataModel?.proposedRemainingInstalments"></basic-payment-list>
        </div>
      </div>
    </div>
  </div>
</div>
